'use strict'

/**
 * Name: Day19 - Text Effect
 * ===========================================
 */

import * as PIXI from 'pixi.js'
import { TimelineMax, Power4, Expo } from 'gsap/TweenMax'
import { loadImage } from '@/helpers/utils'

const IMG = require('@/assets/images/dod19_image_01.jpg')

/**
 * Particle Class
 *
 * @constructor
 */
export class Particle {
  constructor(el, options = {}) {
    this.parentEl = el
    this.app = false
    this.ratio = false
    this.container = false
    this.containerChild = false

    window.addEventListener('debounceResize', this.resize.bind(this))

    this.resourceLoader()
  }

  async resourceLoader() {
    await loadImage(IMG)
    this.initPixi()
  }

  initPixi() {
    const { width, height } = this.parentEl.getBoundingClientRect()
    this.app = new PIXI.Application(width, height, {
      transparent: true,
      resolution: 2,
      autoResize: true,
      antialias: true
    })
    this.parentEl.appendChild(this.app.view)

    this.ratio = width / height
    this.w = this.app.view.width / 2
    this.h = this.app.view.height / 2

    this.container = new PIXI.Container()
    this.container.x = this.app.screen.width / 2
    this.container.y = this.app.screen.height / 2
    this.container.pivot.x = this.app.screen.width / 2
    this.container.pivot.y = this.app.screen.height / 2
    this.app.stage.addChild(this.container)

    const texture = PIXI.Texture.fromImage(IMG)
    const style = new PIXI.TextStyle({
      fontFamily: `'Inter UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Arial, 'Hiragino Sans', sans-serif`,
      fontSize: 500,
      fontWeight: 800,
      fill: 0xffffff,
      align: 'left'
    })

    this.text = new PIXI.Text('Days of Design', style)
    this.text.x = this.w / 10
    // this.text.x = this.w / 2
    this.text.y = this.h / 2
    // this.text.anchor.x = 0.5
    this.text.anchor.y = 0.5
    this.text.scale.set(0.25)

    const godzilla = new PIXI.Sprite(texture)
    godzilla.width = this.w
    godzilla.height = (this.w / 1.68)
    godzilla.x = this.w / 2
    godzilla.y = this.h / 2
    godzilla.anchor.x = 0.5
    godzilla.anchor.y = 0.5
    godzilla.mask = this.text

    this.text.updateText(false)

    this.tl = new TimelineMax({
      repeat: -1
    }).to(this.text, 2.5, {
      ease: Expo.easeInOut,
      pixi: {
        x: this.w / 10,
        scale: 0.25
      }
    }).to(this.text, 2, {
      ease: Power4.easeInOut,
      pixi: {
        x: -((this.text.width * 4))
      }
    }).to(this.container, 3, {
      ease: Power4.easeInOut,
      pixi: {
        x: '+=50',
        scale: 1.1
      }
    }, '-=4').to(this.text, 3, {
      ease: Expo.easeInOut,
      pixi: {
        scale: 1
      }
    }, '-=4')

    this.container.addChild(godzilla)
    this.container.addChild(this.text)
  }

  resize() {
    const { width, height } = this.parentEl.getBoundingClientRect()
    let w
    let h
    if (width / height >= this.ratio) {
      w = height * this.ratio
      h = height
    } else {
      w = width
      h = width / this.ratio
    }
    this.app.view.style.width = `${w}px`
    this.app.view.style.height = `${h}px`
  }

  destroy() {
    this.app.destroy(true)
    this.app = null
  }
}
